<div *ngIf="!isDone else done">
  <span class="progress-text">Processing invoices</span>
  <mat-progress-bar mode="indeterminate" class="progress-bar"></mat-progress-bar>
</div>
<ng-template #done>
  senad
</ng-template>

